import React from "react";
import PropTypes from "prop-types";
import MaterialTitlePanel from "./material_title_panel";
import { NavLink } from 'react-router-dom';
import data from '../products.json';
import { useTranslation } from 'react-i18next';

import { getProductTitle } from '../helpers';

const styles = {
    sidebar: {
      width: 230,
      minHeight: "100%",
      backgroundColor: "white"
    },
    sidebarLink: {
      display: "block",
      padding: "16px 0px",
      color: "#757575",
      textDecoration: "none"
    },
    divider: {
      margin: "8px 0",
      height: 1,
      backgroundColor: "#757575"
    },
    content: {
      padding: "16px",
      height: "100%",
      backgroundColor: "white"
    }
};

const SidebarContent = props => {
  const { t, i18n } = useTranslation();
  const currentLang = (i18n.language || 'hy').slice(0, 2);

  const style = props.style
    ? { ...styles.sidebar, ...props.style }
    : styles.sidebar;

  let final_tags = []
  let logo = process.env.PUBLIC_URL + '/uploads/logo1.webp'

  const sortedData = [...data].sort((a, b) => {
    const titleA = getProductTitle(a, currentLang) || "";
    const titleB = getProductTitle(b, currentLang) || "";

    if (currentLang === 'hy') {
      const isArmA = /^[\u0530-\u058F]/.test(titleA);
      const isArmB = /^[\u0530-\u058F]/.test(titleB);

      if (isArmA && !isArmB) {
        return -1;
      }
      if (!isArmA && isArmB) {
        return 1;
      }
    }

    return titleA.localeCompare(titleB, currentLang);
  });

  const langPrefix = currentLang === 'hy' ? '' : '/' + currentLang;

  sortedData.forEach(
      item => {
          final_tags.push(
            <li key={item['title'] + (item['image'] || '')}>
              <NavLink
                  className="navlink"
                  activeClassName="product-is-active"
                  to={`${langPrefix}/product/${encodeURIComponent(item['title'])}`}
                  onClick={props.toggleSidebar}
                  >
                      {getProductTitle(item, currentLang)} </NavLink>
                      
                      <hr style={{
                        width: "150px",
                        marginRight: "auto",
                        marginLeft: "auto",
                        border: "none",
                        height: "1px",
                        backgroundColor: "#EC268F",
                        }} />
                      </li>
            )
      }
  )

  return (
    <MaterialTitlePanel style={style} showHeader={false}>
      <div className="">
            <br></br>
            <nav className="fh5co-main-menu">
                <div className="mainMenuContainer">
                    <ul>
                        <li>
                            <NavLink className="navlink no-hover" to={langPrefix || "/"} exact={true}>
                                <img src={logo} alt="Tparan.am" style={{ width: 200 }}/>
                            </NavLink>
                        </li>
                    </ul>

                    <ul>
                        <li>
                            <NavLink
                            className="navlink"
                            activeClassName="is-active"
                            to={langPrefix || "/"}
                            onClick={props.toggleSidebar}
                            exact={true}>
                                {t('nav_home')}
                            </NavLink>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <NavLink
                            className="navlink"
                            activeClassName="is-active"
                            to={{pathname: "https://instagram.com/tparan.am"}} // /portfolio
                            target="_blank"
                            onClick={props.toggleSidebar}
                            exact={true}>
                                {t('nav_portfolio')}
                            </NavLink>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <NavLink
                            className="navlink"
                            activeClassName="is-active"
                            to={`${langPrefix}/about`}
                            onClick={props.toggleSidebar}
                            exact={true}>
                                {t('nav_about')}
                            </NavLink>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <NavLink
                            className="navlink"
                            activeClassName="is-active"
                            to={`${langPrefix}/contact`}
                            onClick={props.toggleSidebar}
                            exact={true}>
                                {t('nav_contact')}
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <hr />
                <ul className="productsContainer">
                    {final_tags}
                </ul>
                <div id="tags">
                    
                </div>
            </nav>
        </div>
    </MaterialTitlePanel>
  );
};

SidebarContent.propTypes = {
  style: PropTypes.object
};

export default SidebarContent;